import Request from '@/utils/request'

import { generateRandomString } from '@/utils/common.js'

const MALE_SPIN_HOME = '/api/v2/app/activity/maleSpin/home'
const MALE_SPIN_DRAW = '/api/v2/app/activity/maleSpin/draw/spin'
const MALE_SPIN_HISTORY = '/api/v2/app/activity/maleSpin/draw/history'
const MALE_SPIN_LEADERBOARD = '/api/v2/app/activity/maleSpin/leaderboard'

/** GET 主页（文档 2.1） */
export function maleSpinHome() {
  return Request({
    url: MALE_SPIN_HOME,
    method: 'get',
  })
}

/**
 * POST 抽奖（文档 2.2）
 * @param {{ poolType: string, spinCount: number, idempotencyKey: string }} body
 */
export function maleSpinDraw(body) {
  return Request({
    url: MALE_SPIN_DRAW,
    method: 'post',
    data: body,
  })
}

/** GET 抽奖历史（文档 2.3） */
export function maleSpinDrawHistory(params) {
  return Request({
    url: MALE_SPIN_HISTORY,
    method: 'get',
    params,
  })
}

/** GET 排行榜（文档 2.4） */
export function maleSpinLeaderboard() {
  return Request({
    url: MALE_SPIN_LEADERBOARD,
    method: 'get',
  })
}

/** 生成抽奖幂等键（文档要求每次点击唯一） */
export function newSpinIdempotencyKey() {
  return `${Date.now()}-${generateRandomString(24)}`
}
